export default "__VITE_ASSET__CStzOBjF__"